/**
 * ReactQuill config for the Knowledge Base editor.
 * Extended toolbar: headers, blockquote, code-block, video embed, plus the standard note toolbar.
 */

const MAX_IMAGE_BYTES = 2.5 * 1024 * 1024;

export const KB_QUILL_MODULES = {
  toolbar: {
    container: [
      [{ header: [1, 2, 3, false] }],
      ['bold', 'italic', 'underline', 'strike'],
      ['blockquote', 'code-block'],
      [{ list: 'ordered' }, { list: 'bullet' }],
      ['link', 'image', 'video'],
      ['clean'],
    ],
    handlers: {
      image: function (this: {
        quill: {
          getSelection: (b: boolean) => { index: number; length: number } | null;
          getLength: () => number;
          insertEmbed: (i: number, type: string, value: string, source: string) => void;
          setSelection: (i: number) => void;
        };
      }) {
        const input = document.createElement('input');
        input.setAttribute('type', 'file');
        input.setAttribute('accept', 'image/*');
        input.click();
        input.onchange = () => {
          const file = input.files?.[0];
          if (!file) return;
          if (file.size > MAX_IMAGE_BYTES) {
            window.alert('Image is too large. Maximum size is 2.5 MB.');
            return;
          }
          const reader = new FileReader();
          reader.onload = () => {
            const url = reader.result as string;
            const quill = this.quill;
            const range = quill.getSelection(true);
            const index = range ? range.index : Math.max(0, quill.getLength() - 1);
            quill.insertEmbed(index, 'image', url, 'user');
            quill.setSelection(index + 1);
          };
          reader.readAsDataURL(file);
        };
      },
    },
  },
};

export const KB_QUILL_FORMATS = [
  'header',
  'bold', 'italic', 'underline', 'strike',
  'blockquote', 'code-block',
  'list', 'bullet',
  'link', 'image', 'video',
];
